<template>
  <div>
    <ul class="oldList">
      <li v-for="(list, index) in mapVersionsAgreement" :key="index" @click="oldCange(index)" v-bind:class="{ 'isShow': idx === index }">
        {{ list.object.mapUpdated_at }}
      </li>
    </ul>
    <code-diff :old-string="oldAgreement" :new-string="newAgreement" :context="10" :output-format="outputFormat" />
  </div>
</template>

<script>
import vueCodeDiff from 'vue-code-diff'
export default {
  props: {
    agreement: Object
  },

  components: {
    'code-diff': vueCodeDiff
  },

  data () {
    return {
      idx: 0,

      oldStr: 'f_name aaa',
      newStr: 'f_name bbb',
      outputFormat: 'side-by-side',
      // outputFormat: 'line-by-line'

      columnName: {
        id: 'ID',
        office: '営業所', // office_idではなくこっちつかってた、、、
        user_id: '編集者', // whodunnitにしないと。user_idは編集しても変わらない。
        // mapUser_id: '編集者',
        student_id: '生徒ID',
        label: '',
        contract_type: '契約種類',
        contract_date: '契約日付',
        change_date: '内容変更日付',
        cancel_type: '解約種類',
        cancel_date: '解約日付',
        f_name: '苗字',
        l_name: '名前',
        f_name_kana: '苗字かな',
        l_name_kana: '名前かな',
        tel: '携帯TEL',
        tel2: '固定',
        address: '住所',
        address2: '住所2',
        deposit_amount_date: 'テキスト代入金日',
        person: '担当者',
        product_name: '商品名',
        payment_type: '支払方法種別',
        text_type: 'テキスト種類',
        amount: '定価',
        discount: '値引',
        pure_amount: '販売価格',
        division_commission: '分割手数料',
        total_amount: 'お支払総額',
        payments_number: '支払回数',
        text_payment_period_start: '支払期間/開始(テキスト)',
        text_payment_period_end: '支払期間/終了(テキスト)',
        first_month_deposit_method: '初月管理費支払方法',
        first_month_deposit_check: '初月管理費チェック',
        admission_fee: '入会金',
        admission_fee_method: '入会金支払方法',
        admission_fee_check: '入会金チェック',
        deposit: '保証金',
        deposit_method: '保証金支払方法',
        deposit_check: '保証金チェック',
        deposit_refund_date: '保証金返金日',
        approval_date: '承認日',
        approval_number: '承認No.',
        delivery_date: '納品日',
        contract_collection_date: '契約書回収日',
        factor_collection_date: 'ファクター回収日',
        grade: '学年',
        point_total: '合計P',
        note: '備考',
        mapCreated_at: '作成日',
        mapUpdated_at: '更新日'
      }
    }
  },

  computed: {
    versionsAgreement () {
      return this.$store.getters.versionsAgreement
    },

    mapVersionsAgreement () {
      return this.versionsAgreement.map(item => {
        // item.object.mapUser_id = this.calcArry(item.object.user_id, 'users')
        item.object.mapUser_id = item.object.user_id
        item.object.mapCreated_at = this.calcDateTime(item.object.created_at)
        item.object.mapUpdated_at = this.calcDateTime(item.object.updated_at)
        return item
      })
    },

    keys () {
      return Object.keys(this.columnName)
    },

    office () {
      return this.$store.getters['agreements/office']
    },

    users () {
      return this.$store.getters.users
    },

    newAgreement () {
      return this.keys.map(key => {
        if (key === 'mapCreated_at') {
          const val = this.calcDateTime(this.agreement.created_at)
          const label = this.columnName[key] || key
          return label + ' ' + val
        } else if (key === 'mapUpdated_at') {
          const val = this.calcDateTime(this.agreement.updated_at)
          const label = this.columnName[key] || key
          return label + ' ' + val
        } else {
          const val = this.agreement[key]
          const label = this.columnName[key] || key
          return label + ' ' + val
        }
      }).join('\n')
    },

    oldAgreement () {
      return this.keys.map(key => {
        if (this.versionsAgreement.length === 0) {
          return
        } else {
          const obj = this.versionsAgreement[this.idx].object
          const val = obj[key]
          const label = this.columnName[key] || key
          return label + ' ' + val
        }
      }).join('\n')
    }
  },

  methods: {
    oldCange (idx) {
      this.idx = idx
    },

    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    }
  }
}
</script>

<style lang="scss" scoped>
.oldList {
  padding: 5px;
  margin: 0;
  li {
    list-style: none;
    cursor: pointer;
    &:hover {
      color: #41b883;
    }
  }
}
.isShow {
  color: #41b883;
}
</style>



// WEBPACK FOOTER //
// AgreementDiff.vue?46f72b96